The type of event, i.e. `PositionNotPosted`.
